import { useNewCode } from '@calendly/feature-check-react';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { Spotlight } from 'components/core/spotlight';
import { hideUpgradeNotetakerSpotlight, isUpgradeNotetakerSpotlightVisibleSelector } from 'features/upgrade_banner';
import { DropDownUserMenu } from './drop-down-user-menu';
import { OldDropDownUserMenu } from './old-drop-down-user-menu';
const spotlightContainerCss = "s1xhv0dm";
export const UserMenu = () => {
  const dispatch = useDispatch();
  const isNewUserMenu = useNewCode('account_dropdown_menu')?.enabled;
  const shouldShowSpotlight = useSelector(isUpgradeNotetakerSpotlightVisibleSelector);
  const pendoProps = {
    'data-pendo-id': 'crm-contacts-enabled'
  };
  const MenuComponent = isNewUserMenu ? DropDownUserMenu : OldDropDownUserMenu;
  return <div className={spotlightContainerCss}>
      {shouldShowSpotlight && <Spotlight theme="classic" placement="bottom-left" secondaryOffset={-10} bodyText={HtmlParser(I18n.t('publisher.upgrade_banner.notetaker.dismiss_spotlight.body'))} showClose={false} onClickPrimary={() => dispatch(hideUpgradeNotetakerSpotlight())} primaryButtonLabel={I18n.t('publisher.upgrade_banner.notetaker.dismiss_spotlight.primary_button')} />}
      <MenuComponent {...pendoProps} />
    </div>;
};

require("./user_menu.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./user_menu.js");